<template>
  <v-app>
    <v-app-bar app>
      <section v-if="user">
        <v-avatar class="mr-2">
          <img :src="user.imageUrl" :alt="user.name" />
        </v-avatar>
        Angemeldet als {{ user.fullName }}.
      </section>
      <v-spacer />
      <Login :user="user" v-on:login="login" v-on:logout="logout" />
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main class="grey lighten-3">
      <v-container v-if="!user" class="fill-height" fluid>
        <v-row justify="center" dense>
          <v-col cols="12" sm="8" md="4" lg="4" align="center">
            <v-btn :disabled="user" large outlined @click="login()" type="button" v-if="!user" style="text-transform: none !important">
              <img src="./assets/g-logo.svg" alt="" srcset="" style="vertical-align: middle; padding-right: 24px" />
              Anmelden mit Google
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="user">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6" v-if="tochange"
            ><Template :form="tochange.form" :index="tochange.index" v-on:cancel="cancel" v-on:save="save"
          /></v-col>
          <v-col cols="12" sm="8" md="6" v-if="!tochange">
            <TemplateList
              :templates="templates"
              v-on:use-template="useTemplate"
              v-on:change-template="changeTemplate"
              v-on:create-template="createTemplate"
            />
          </v-col>
          <v-col cols="12" sm="8" md="6" v-if="!tochange && selected">
            <EventAdder :events="events" :template="selected" v-on:add-event="addEvent" v-on:show-snack-bar="showSnackBar" />
          </v-col>
          <!-- <Temp /> -->
        </v-row>
        <!-- <Calendar :events="events" :template="selected" /> -->
        <!-- If using vue-router -->
        <!-- <router-view></router-view> -->
        <v-row v-if="error">
          <v-col>
            <pre>{{ JSON.stringify(error) }}</pre>
          </v-col>
        </v-row>
      </v-container>
      <SnackBar :snackbar="snackbar" />
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import Login from "./components/Login";
import Template from "./components/Template.vue";
import TemplateList from "./components/TemplateList";
import EventAdder from "./components/EventAdder";
import SnackBar from "./components/SnackBar";
// import Temp from "./components/Temp";
// import Calendar from "./components/Calendar";

import templates from "./templates";
import empty from "./emptytemplate";

const NEWTEMPLATE = -1;

const TEMPLATESUMMARY = "templates for calendar app - do not edit or delete";
const TEMPLATESTART = "1970-01-01T08:15:00";
const TEMPLATEEND = "1970-01-01T08:15:59";
const TEMPLATETZ = "Europe/Berlin";
const TEMPLATEID = "ee7c8a50d84e11eba57b0f93238564cc";

export default {
  name: "App",

  components: {
    Login,
    TemplateList,
    Template,
    EventAdder,
    SnackBar,
    // Temp,
    // Calendar,
  },

  data: () => ({
    user: undefined,
    templates,
    selected: undefined,
    tochange: undefined,
    events: [],
    snackbar: {
      show: false,
      text: "",
      color: "info",
      timeout: 100,
    },
    error: undefined,
  }),

  created() {
    // (2) Subscribe to authentication status changes
    this.$gapi.listenUserSignIn((isSignedIn) => {
      this.loginError("");
      this.user = isSignedIn ? this.$gapi.getUserData() : undefined;
      if (this.user) {
        this.getTemplateStorage();
        this.getCalendarEvents();
      }
    });
  },

  methods: {
    login() {
      this.$gapi
        .login()
        .then(({ currentUser, hasGrantedScopes }) => {
          console.log({ currentUser, hasGrantedScopes });
          this.showSnackBar(`Anmeldung erfolgreich.`, "success");
        })
        .catch((err) => {
          this.showSnackBar("Fehler bei der Anmeldung.", "error");
          this.loginError(err);
          console.error(`exception during login: ${err}`);
        });
    },
    logout() {
      this.loginError("");
      this.$gapi.logout();
    },
    useTemplate: function (template) {
      this.selected = template;
      this.tochange = undefined;
    },
    changeTemplate: function (index) {
      this.tochange = { index, form: { ...this.templates[index] } };
      this.selected = undefined;
    },
    createTemplate: function () {
      this.tochange = { index: NEWTEMPLATE, form: { ...empty } };
      this.selected = undefined;
    },
    cancel: function () {
      this.tochange = undefined;
    },
    save: function (index, template) {
      if (NEWTEMPLATE == index) this.templates.push(template);
      else this.templates[index] = template;
      this.saveTemplates();
      this.tochange = undefined;
    },
    addEvent: function (event) {
      this.events.push(event);
    },
    showSnackBar: function (text, color = "info", timeout = 5000) {
      this.snackbar = { show: true, text, color, timeout };
    },
    loginError: function (error) {
      this.error = error;
    },
    getTemplateStorage() {
      this.$gapi.getGapiClient().then((gapi) => {
        gapi.client.calendar.events
          .get({
            calendarId: "primary",
            eventId: TEMPLATEID,
          })
          .then((response) => {
            console.debug(response.result);
            this.templates = JSON.parse(response.result.description);
          })
          .catch((err) => {
            console.log(err);
            this.showSnackBar("Laden der Vorlagen fehlgeschlagen!", "info");
            this.initTemplateStorage();
          });
      });
    },
    initTemplateStorage() {
      const event = {
        id: TEMPLATEID,
        summary: TEMPLATESUMMARY,
        description: JSON.stringify(this.templates),
        start: {
          dateTime: TEMPLATESTART,
          timeZone: TEMPLATETZ,
        },
        end: {
          dateTime: TEMPLATEEND,
          timeZone: TEMPLATETZ,
        },
      };
      this.$gapi.getGapiClient().then((gapi) => {
        gapi.client.calendar.events
          .insert({
            calendarId: "primary",
            resource: event,
          })
          .then((response) => {
            this.showSnackBar("Die Vorlagen wurden erfolgreich angelegt.", "success");
            console.debug(response.result);
          })
          .catch((error) => {
            this.showSnackBar("Speichern der Vorlagen fehlgeschlagen.", "error");
            console.error(error);
          });
      });
    },
    saveTemplates() {
      const event = {
        summary: TEMPLATESUMMARY,
        description: JSON.stringify(this.templates),
        start: {
          dateTime: TEMPLATESTART,
          timeZone: TEMPLATETZ,
        },
        end: {
          dateTime: TEMPLATEEND,
          timeZone: TEMPLATETZ,
        },
      };
      console.debug(event);
      this.$gapi.getGapiClient().then((gapi) => {
        gapi.client.calendar.events
          .update({
            calendarId: "primary",
            eventId: TEMPLATEID,
            resource: event,
          })
          .then((response) => {
            this.showSnackBar("Die Vorlagen wurden erfolgreich gespeichert.", "success");
            console.debug(response.result);
          })
          .catch((error) => {
            this.showSnackBar("Speichern der Vorlagen fehlgeschlagen.", "error");
            console.error(error);
          });
      });
    },
    getCalendarEvents() {
      console.debug("trying to get calendar events");
      this.$gapi
        .getGapiClient()
        .then((resp) => {
          console.debug(resp);
          const date = new Date();
          const timeMin = new Date(date.getFullYear(), date.getMonth(), 1);
          const timeMax = new Date(date.getFullYear(), date.getMonth() + 4, 0);
          resp.client.calendar.events
            .list({
              calendarId: "primary",
              timeMin: timeMin.toISOString(),
              timeMax: timeMax.toISOString(),
              showDeleted: false,
              singleEvents: true,
              maxResults: 200,
              orderBy: "startTime",
            })
            .then((response) => {
              this.events = response.result.items;
              console.log(this.events);
            });
        })
        .catch((err) => {
          console.log(err);
          this.showSnackBar(err, "error");
        });
    },
  },
};
</script>
